import { createTransform } from 'redux-persist';

export const removeLoadingAndErrorsTransform = createTransform<
  Record<string, unknown>,
  Record<string, unknown>
>(
  (inboundState) => {
    if (!inboundState || typeof inboundState !== 'object') {
      return inboundState;
    }

    const newState = { ...inboundState };

    Object.keys(newState).forEach((field) => {
      if (field.includes('isLoading')) {
        newState[field] = false;
      } else if (field === 'errorMsg') {
        newState[field] = '';
      } else if (field === 'fieldErrors') {
        newState[field] = {};
      } else if (
        field === 'isDeleteLoading' ||
        field === 'isLoadingPreview' ||
        field === 'isHistoryDetailsLoading' ||
        field === 'isSvcLocationsLoading' ||
        field === 'isUpdateAddressLoading'
      ) {
        newState[field] = false;
      }
    });

    return newState;
  },
  (outboundState) => outboundState
);
